import { render, staticRenderFns } from "./personContractComponent.vue?vue&type=template&id=5ccdcf3c&scoped=true&"
import script from "./personContractComponent.vue?vue&type=script&lang=js&"
export * from "./personContractComponent.vue?vue&type=script&lang=js&"
import style0 from "./personContractComponent.vue?vue&type=style&index=0&id=5ccdcf3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccdcf3c",
  null
  
)

export default component.exports